import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const CountryList = () => {
    const [countries, setCountries] = useState([]);

    useEffect(() => {
        axios.get('https://kyrgyz-adventure-travel.com/api/v1/tours/country-list')
            .then(response => setCountries(response.data.results))
            .catch(error => console.error('Error loading data:', error));
    }, []);

    return (
        <ul className="py-2">
            {countries.map(country => (
                <li key={country.id}>
                    <Link
                        to={`/country/${country.id}`}
                        className="block px-5 py-3 font-manrope text-sm text-white/70 hover:text-gold hover:bg-white/5 capitalize transition-all duration-200"
                    >
                        {country.name}
                    </Link>
                </li>
            ))}
        </ul>
    );
};

export default CountryList;
